import axios from "axios";

const apiKey = "sk_live_prime_website_9g6z4b7c1b8e7uyck"

// For enquiry API (configurable via .env)

export const enquiryApi = axios.create({
  baseURL: "https://sourceone.co.bw/api/v1/prime-precision-imaging",
  headers: {
     "X-Api-Key": apiKey,
  },
});

// For another API (hard‑coded or could also use another env var)
const api = axios.create({
  baseURL: "https://prime-precision-backend-server-il2j.onrender.com/api",
});

export default api;
